export function useRegisterV2Step() {
  const currentStep = useState<number>('registerV2Step', () => 1);

  const setStep = (step: number) => {
    currentStep.value = step;
  };

  return {
    currentStep,
    setStep,
  };
}
